import { render, staticRenderFns } from "./PartiallyAcceptedTabs.vue?vue&type=template&id=07dcb5d4&scoped=true&"
import script from "./PartiallyAcceptedTabs.vue?vue&type=script&lang=js&"
export * from "./PartiallyAcceptedTabs.vue?vue&type=script&lang=js&"
import style0 from "./PartiallyAcceptedTabs.vue?vue&type=style&index=0&id=07dcb5d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dcb5d4",
  null
  
)

export default component.exports